<template>
  <div class="login-container">
    <div class="login-box">
      <h2>Вход в систему</h2>

      <!-- Выпадающий список пользователей -->
      <select v-model="selectedUser" class="login-select">
        <option disabled value="">Выберите пользователя</option>
        <option v-for="user in users" :key="user.id" :value="user">{{ user.label }}</option>
      </select>

      <!-- Поле для ввода пароля -->
      <input
        type="password"
        v-model="password"
        placeholder="Введите пароль"
        class="login-input"
      />

      <button @click="login" class="omnica-button omnica-button_primary omnica-button_md omnica-button_ellipsis _full-width_1caa7_10">Войти</button>
    </div>
  </div>
</template>

<script>
import { sortManagersByLabel } from '@/constants/sortManagers';

export default {
  name: 'UserLogin',
  data() {
    return {
      users: [],
      selectedUser: null,
      password: ''
    };
  },
  async created() {
    try {
      const response = await fetch('https://manager.1akb.by/users-list');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      this.users = sortManagersByLabel(await response.json());
    } catch (error) {
      console.error('Ошибка при загрузке списка пользователей:', error);
    }
  },
  methods: {
  async login() {
    if (!this.selectedUser) {
      alert('Пожалуйста, выберите пользователя');
      return;
    }

    if (!this.password) {
      alert('Пожалуйста, введите пароль');
      return;
    }

    try {
      const response = await fetch('https://manager.1akb.by/auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: this.selectedUser.id,
          password: this.password
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        alert(`Ошибка сервера: ${response.status} - ${errorText}`);
        return;
      }

      const result = await response.json();

      if (!result.success) {
        alert(result.error || 'Ошибка авторизации');
        return;
      }

      // Канонический идентификатор сессии — внутренний users_settings.id.
      // retailCrmId храним отдельно, чтобы не смешивать домены ID.
      const user = {
        id: result.user.id,
        label: result.user.label,
        phone_extension: result.user.internalPhone,
        login_talkme: result.user.talkMeLogin,
        role: result.user.group_name,
        firstName: result.user.firstName,
        lastName: result.user.lastName,
        email: result.user.email,
        mobilePhone: result.user.mobilePhone,
        retailCrmId: result.user.retailCrmId,
        symbolicCode: result.user.symbolicCode,
        id_talkme: result.user.id_talkme,
        delay: result.user.delay,
        photo: result.user.photo
      };

      const loginTime = Date.now();
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('loginTime', loginTime);

      this.$store.commit('setUser', user);

      // Если авторизуется клиент "sto@1akb.by", перенаправляем сразу на нужную страницу
      if (result.user.label.trim() === 'sto@1akb.by') {
        this.$router.push('/tasksto');
        return;
      }

      // Для остальных пользователей используем роутер Vue
      this.$router.push('/');
      
    } catch (error) {
      console.error('Ошибка при авторизации:', error);
      alert('Ошибка соединения с сервером');
      return;
    }
  },
}

};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
  padding: 0 20px; /* Добавим боковые отступы для контейнера */
}

.login-box {
background-color: #ffffff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 100%;
    max-width: 450px;
    box-sizing: border-box;
}

h2 {
    font: 800 40px / 44px Gilroy, Arial, Helvetica, sans-serif;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 42px;
}


.login-select,
.login-input {
  width: 100%;
  height: 48px!important;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box; /* Учитываем padding в ширину элемента */
}





.omnica-button {
    --omnica-button-text-color: #1E2248;
    display: inline-block;
    box-sizing: border-box;
    padding: 0 20px;
    background-image: none;
    border: none;
    border-radius: 6px;
    outline: none !important;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    line-height: normal;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    color: var(--omnica-button-text-color);
    cursor: pointer;
    appearance: none;
    user-select: none;
    touch-action: manipulation;
    vertical-align: top;
    transition: color .25s ease, background .25s ease, box-shadow .25s ease, border .25s ease, width 0s;
}

.omnica-button, .omnica-button:active, .omnica-button:focus {
    outline: none;
    box-shadow: none;
}

.omnica-button_primary {
    --omnica-button-background-color: #005EEB;
    --omnica-button-background-color-active: #0052CC;
    --omnica-button-background-color-disabled: #B8DBFF;
    --omnica-button-background-image: linear-gradient(180deg, #0068FF 0%, #005BD5 100%);
    --omnica-button-text-color: white;
    background-color: var(--omnica-button-background-color);
    background-image: var(--omnica-button-background-image);
    font-weight: 500;
}

.omnica-button_md {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    height: 48px;
    min-width: 128px;
    padding: 0 24px;
    border-radius: 8px;
}

._full-width_1caa7_10 {
    width: 100%;
}

.login-container {
  width: 100%;
}


.omnica-button__inner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.omnica-button_ellipsis .omnica-button__text {
    overflow: hidden;
    text-overflow: ellipsis;
}

.sticky-saved-orders {
  display:none;
}
</style>

